/**
 * Created by Ning Jiang on 2023-09-13.
 */

import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadLayers, Layers} from "./DevilsCrossRoadLayers";
import {DCRoadReelsView} from "../reels/DCRoadReelsView";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {gsap, TimelineLite} from "gsap";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";

export class DevilView {

    // this index match the devway index.
    private _idleNames:string[][] = [
        ["idle_look_left", "idle_look_up", "idle_look_down", "idle_look_right", "idle"],
        ["popout1_idle", "popout1_idle", "popout1_idle", "popout1_idle", "popout1_idle"]
    ];

    private _headSpine:PIXI.spine.Spine;
    private _bodySpine:PIXI.spine.Spine;
    private _smokeSpine:PIXI.spine.Spine;
    private _idlePlaying:boolean;
    private _currentLevel:number = 0;

    constructor() {
        this.initSpine();
        this.playIdle();
        this._smokeSpine.state.setAnimation(0, "idle", true);
    }

    protected initSpine():void {
        // TODO: restore devil state in avalanche.
        const position = DCRoadReelsView.SYMBOL_POSITIONS[2][2];

        this._headSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("D"));
        this._headSpine.autoUpdate = true;
        this._headSpine.position.set(DCRoadReelsView.REELS_CENTER[0] + position[0], DCRoadReelsView.REELS_CENTER[1] + position[1]);
        DevilsCrossRoadLayers.getLayer(Layers.DEVIL_HEAD)?.addChild(this._headSpine);

        this._bodySpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("DBody"));
        this._bodySpine.autoUpdate = true;
        this._bodySpine.position.set(DCRoadReelsView.REELS_CENTER[0] + position[0], DCRoadReelsView.REELS_CENTER[1] + position[1]);
        DevilsCrossRoadLayers.getLayer(Layers.DEVIL_BODY)?.addChild(this._bodySpine);

        this._smokeSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("mainReelSmoke"));
        this._smokeSpine.autoUpdate = true;
        this._smokeSpine.position.set(DCRoadReelsView.REELS_CENTER[0] + position[0], DCRoadReelsView.REELS_CENTER[1] + position[1]);
        DevilsCrossRoadLayers.getLayer(Layers.REEL_SMOKE)?.addChild(this._smokeSpine);
    }

    public playIdle():void {
        if(this._idlePlaying && this._currentLevel === 0) {
            return;
        }
        this._idlePlaying = true;
        if(this._currentLevel != 0) {
            this._currentLevel = 0;
            const tl = gsap.timeline();
            tl.add(() => {
                const headEntry = this._headSpine.state.setAnimation(0, "popout1_reverse", false);
                headEntry.mixDuration = 0.5;
                const bodyEntry = this._bodySpine.state.setAnimation(0, "popout1_reverse", false);
                bodyEntry.mixDuration = 0.5;
            });
            tl.add(() => {
                this.playIdleLoop();
            }, this._headSpine.spineData.findAnimation("popout1_reverse").duration);
        } else {
            this.playIdleLoop();
        }
    }

    private playIdleLoop():void {
        if(!this._idlePlaying) {
            return;
        }
        const tl = gsap.timeline();
        tl.add(() => {
            const name = ArrayHelper.getRandomValue(this._idleNames[this._currentLevel]);
            const headEntry = this._headSpine.state.setAnimation(0, name, true);
            headEntry.mixDuration = 0.5;
            const bodyEntry = this._bodySpine.state.setAnimation(0, name, true);
            bodyEntry.mixDuration = 0.5;
        });
        tl.add(() => {
            this.playIdleLoop();
        }, Math.max(1, Math.random() * 4));
    }

    // TODO: use this before change states.
    private stopIdle():void {
        this._idlePlaying = false;
    }

    public playWinAnimation(devWay:number):TimelineLite {
        this.stopIdle();
        const tl = gsap.timeline();
        tl.add(() => {
            const name = this._idleNames[this._currentLevel][devWay];
            const headEntry = this._headSpine.state.setAnimation(0, name, true);
            headEntry.mixDuration = 0.5;
            const bodyEntry = this._bodySpine.state.setAnimation(0, name, true);
            bodyEntry.mixDuration = 0.5;
        });
        tl.add(() => {}, 0.5);
        return tl;
    }

    public playWild():TimelineLite {
        const tl = gsap.timeline();
        tl.add(() => {
            this.stopIdle();
            const headEntry = this._headSpine.state.setAnimation(0, 'wild_appear', false);
            headEntry.mixDuration = 0.5;
            const bodyEntry = this._bodySpine.state.setAnimation(0, 'wild_appear', false);
            bodyEntry.mixDuration = 0.5;
        });
        tl.add(() => {}, this._headSpine.spineData.findAnimation("wild_appear").duration);
        return tl;
    }

    public playSpin():void {
        this.stopIdle();
        // TODO:level up avalanche?
    }

    public playAvalancheSpin():void {
        this.stopIdle();
        if(this._currentLevel === 0) {
            this._currentLevel++;
            const tl = gsap.timeline();
            tl.add(() => {
                const headEntry = this._headSpine.state.setAnimation(0, "popout1", false);
                headEntry.mixDuration = 0.5;
                const bodyEntry = this._bodySpine.state.setAnimation(0, "popout1", false);
                bodyEntry.mixDuration = 0.5;
                DevilsCrossRoadSound.playDevilLaugh();
            });
            tl.add(() => {
                this.playSpin();
            }, this._headSpine.spineData.findAnimation("popout1").duration);
        } else {
            this.playSpin();
        }
    }

    public show(value:boolean):void {
        this._headSpine.visible = value;
        this._bodySpine.visible = value;
        this._smokeSpine.visible = value;
    }
}